<template>
<Layout id="LeaveApprove" v-if="visable">
  <LayoutHeader class="home-header">
        <Row>
          <Col :offset="17" :span="1">
            <LanguageButton />
          </Col>
        </Row>
      </LayoutHeader>
      <LayoutContent class="home-content">
    <Row>
      
    <Col :span="24" class="title">
      <TypographyTitle>{{ $t("nav.name.LeaveManage") }}</TypographyTitle>
    </Col>
    </Row>
    <Row type="flex" justify="space-between" style="margin-top:20px;">
      <Col :span="11" class="content" style="border-left: 10px solid rgb(24, 144, 255);border-radius: 5px;">
        <Row>
          <Col :span="12" style="font-size:16pt;font-weight:bold;">
            {{$t('leaveApprove.name.employeeInfo')}}
          </Col>
          <Col :span="12" style="text-align:right;color:red;" v-if="data.status">
          {{
        selectList.statusList.find(item=>item.value===data.status).label
      }}
          </Col>

        </Row>
        <Row style="padding-left:15px;padding-right:15px;margin-top:15px;">
          <Col :span="12" >
            <span style="font-size:12pt;color:#7D8199">{{$t('leave.field.id_lea')}}</span>&nbsp;&nbsp;&nbsp;<span style="font-size:14pt;">{{
          data.idLea
        }}</span>
          </Col>
          <Col :span="12" style="text-align:left">
          <span style="font-size:12pt;color:#7D8199">{{$t('leave.field.id_emp')}}</span>&nbsp;&nbsp;&nbsp;<span style="font-size:14pt;">{{
          data.employeeNameTw
        }}</span>
          </Col>
        </Row>
        <Row style="padding-left:15px;padding-right:15px;margin-top:15px;">
          <Col :span="12" >
            <span style="font-size:12pt;color:#7D8199">{{$t('leave.field.leave_type')}}</span>&nbsp;&nbsp;&nbsp;<span style="font-size:14pt;">{{
            data.leaveTypeLeaveTypeName
          }}</span>
          </Col>
          <Col :span="12" style="text-align:left">
          <span style="font-size:12pt;color:#7D8199">{{$t('leave.field.duration')}}</span>&nbsp;&nbsp;&nbsp;<span style="font-size:14pt;">{{
          data.duration + '天'
        }}</span>
          </Col>
        </Row>
        <Row style="padding-left:15px;padding-right:15px;margin-top:15px;">
          <Col :span="12" >
            <span style="font-size:12pt;color:#7D8199">{{$t('leave.field.reason')}}</span>&nbsp;&nbsp;&nbsp;<span style="font-size:14pt;">{{
          data.reason
        }}</span>
          </Col>
          <Col :span="12" style="text-align:left">
          <span style="font-size:12pt;color:#7D8199">{{$t('leave.field.remark')}}</span>&nbsp;&nbsp;&nbsp;<span style="font-size:14pt;">{{
          data.remark
        }}</span>
          </Col>
        </Row>
        <Row style="padding-left:15px;padding-right:15px;margin-top:15px;">
          <Col :span="12" >
            <span style="font-size:12pt;color:#7D8199">{{$t('leave.field.start_time')}}</span>&nbsp;&nbsp;&nbsp;<span style="font-size:14pt;">{{
          data.startTime
        }}</span>
          </Col>
          <Col :span="12" style="text-align:left">
          <span style="font-size:12pt;color:#7D8199">{{$t('leave.field.end_time')}}</span>&nbsp;&nbsp;&nbsp;<span style="font-size:14pt;">{{
          data.endTime
        }}</span>
          </Col>
          <Col :span="12" style="text-align:left;margin-top:30px;">
            <Button type="danger" v-if="data.status === 1 && ((!data.approveTime && data.approverId === this.$store.getters.getId) || (!data.approve2Time && data.approver2Id === this.$store.getters.getId))" @click="reject">{{$t('leaveApprove.name.reject')}}</Button>&nbsp;
            <Button type="danger" v-if="data.status === 1 && ((!data.approveTime && data.approverId === this.$store.getters.getId) || (!data.approve2Time && data.approver2Id === this.$store.getters.getId))" @click="approve">{{$t('leaveApprove.name.pass')}}</Button>
          </Col>
        </Row>

      </Col>
      <Col :span="11" class="content" style="border-left: 10px solid rgb(54, 169, 176);border-radius: 5px;">
        <Row>
          <Col :span="24">
            <span style="font-size:16pt;font-weight:bold;">{{$t('leaveApprove.name.remainingVacation')}}</span>&nbsp;&nbsp;&nbsp;
            <span style="color:#7D8199;font-size:12pt">{{
          remainingVacation.year
        }}</span>
          </Col>
        </Row>
        <Row style="font-size: 14pt;margin-bottom:20px;margin-top:20px;">
        <Col span="6" style="text-align: center;border-right:1px solid rgb(217, 218, 224)">
          <div style="color:#7D8199;font-size:12pt">
            {{$t('remainingVacation.field.annual_leave_days')}}
          </div>
          <div style="font-size:16pt">
            {{ remainingVacation.annualLeaveDays }}
          </div>
        </Col>
      
        <Col span="6" style="text-align: center;border-right:1px solid rgb(217, 218, 224)">
          <div style="color:#7D8199;font-size:12pt">
            {{$t('remainingVacation.field.maternity_leave_days')}}
          </div>
          <div style="font-size:16pt">
            {{ remainingVacation.totalMaternity }}
          </div>
        </Col>
        
        <Col span="6" style="text-align: center;">
          <div style="color:#7D8199;font-size:12pt">
            {{$t('remainingVacation.field.paternity_leave_days')}}
          </div>
          <div style="font-size:16pt">
            {{ remainingVacation.totalPaternity }}
          </div>
        </Col>
        <Col span="6" style="text-align: center;">
          <div style="color:#7D8199;font-size:12pt">
            {{$t('remainingVacation.field.sick_leave_days')}}
          </div>
          <div style="font-size:16pt">
            <!-- {{ totalSickLeaveDays }} -->
            {{ remainingVacation.tmpSickLeaveDays }}

          </div>
        </Col>
      </Row>
      <Row style="font-size: 14pt;margin-bottom:20px;margin-top:20px;">
        <Col span="6" style="text-align: center;border-right:1px solid rgb(217, 218, 224)">
          <div style="color:#7D8199;font-size:12pt">
            {{$t('remainingVacation.field.remaining_annual_leave_days')}}
          </div>
          <div style="font-size:16pt">
            {{ remainingVacation.remainingAnnualLeaveDays }}
          </div>
        </Col>
      
        <Col span="6" style="text-align: center;border-right:1px solid rgb(217, 218, 224)">
          <div style="color:#7D8199;font-size:12pt">
            {{$t('remainingVacation.field.remaining_maternity_leave_days')}}
          </div>
          <div style="font-size:16pt">
            {{ remainingVacation.remainingMaternityLeaveDays }}
          </div>
        </Col>
        
        <Col span="6" style="text-align: center;">
          <div style="color:#7D8199;font-size:12pt">
            {{$t('remainingVacation.field.remaining_paternity_leave_days')}}
          </div>
          <div style="font-size:16pt">
            {{ remainingVacation.remainingPaternityLeaveDays }}
          </div>
        </Col>
        <Col span="6" style="text-align: center;">
          <div style="color:#7D8199;font-size:12pt">
            {{$t('remainingVacation.field.remaining_sick_leave_days')}}
          </div>
          <div style="font-size:16pt">
            {{ remainingVacation.remainingSickLeaveDays }}
          </div>
        </Col>
      </Row>
      </Col>


    </Row>
    <Row style="margin-top:30px;background-color:white;padding:20px;">
    <Col :span="24" class="title">
      <TypographyTitle>{{ $t("leaveApprove.name.historyLeave") }}</TypographyTitle>
    </Col>
     <Col :span="24">
      <!--<Descriptions :title="$t('leaveApprove.name.employeeInfo')">
        <DescriptionsItem :label="$t('leave.field.id_lea')">{{
          data.idLea
        }}</DescriptionsItem>
        <DescriptionsItem :label="$t('leave.field.id_emp')">{{
          data.employeeNameTw
        }}</DescriptionsItem>
        <DescriptionsItem
          :label="$t('leave.field.leave_type')"
          >{{
            data.leaveTypeLeaveTypeName
          }}</DescriptionsItem
        >
        <DescriptionsItem :label="$t('leave.field.start_time')">{{
          data.startTime
        }}</DescriptionsItem>
        <DescriptionsItem :label="$t('leave.field.end_time')">{{
          data.endTime
        }}</DescriptionsItem>
        <DescriptionsItem :label="$t('leave.field.duration')">{{
          data.duration + '天'
        }}</DescriptionsItem>
        <DescriptionsItem :label="$t('leave.field.reason')">{{
          data.reason
        }}</DescriptionsItem>
        <DescriptionsItem :label="$t('leave.field.status')" v-if="data.status">{{
        selectList.statusList.find(item=>item.value===data.status).label
      }}</DescriptionsItem>
        <DescriptionsItem :label="$t('leave.field.approver_id')">{{
        data.approverId
      }}</DescriptionsItem>
      <DescriptionsItem :label="$t('leave.field.approve_time')">{{
        data.approveTime
      }}</DescriptionsItem>
        <DescriptionsItem :label="$t('leave.field.cc')">{{
        data.cc
      }}</DescriptionsItem>
        <DescriptionsItem :label="$t('leave.field.remark')">{{
          data.remark
        }}</DescriptionsItem>
        <DescriptionsItem :label="$t('leave.field.reject_reason')" v-if="data.rejectReason">{{
          data.rejectReason
        }}</DescriptionsItem>
        <DescriptionsItem :label="$t('leave.field.picture_url')">
        <Image
          :width="200"
          :src="data.pictureUrl"
          fallback="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMIAAADDCAYAAADQvc6UAAABRWlDQ1BJQ0MgUHJvZmlsZQAAKJFjYGASSSwoyGFhYGDIzSspCnJ3UoiIjFJgf8LAwSDCIMogwMCcmFxc4BgQ4ANUwgCjUcG3awyMIPqyLsis7PPOq3QdDFcvjV3jOD1boQVTPQrgSkktTgbSf4A4LbmgqISBgTEFyFYuLykAsTuAbJEioKOA7DkgdjqEvQHEToKwj4DVhAQ5A9k3gGyB5IxEoBmML4BsnSQk8XQkNtReEOBxcfXxUQg1Mjc0dyHgXNJBSWpFCYh2zi+oLMpMzyhRcASGUqqCZ16yno6CkYGRAQMDKMwhqj/fAIcloxgHQqxAjIHBEugw5sUIsSQpBobtQPdLciLEVJYzMPBHMDBsayhILEqEO4DxG0txmrERhM29nYGBddr//5/DGRjYNRkY/l7////39v///y4Dmn+LgeHANwDrkl1AuO+pmgAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAwqADAAQAAAABAAAAwwAAAAD9b/HnAAAHlklEQVR4Ae3dP3PTWBSGcbGzM6GCKqlIBRV0dHRJFarQ0eUT8LH4BnRU0NHR0UEFVdIlFRV7TzRksomPY8uykTk/zewQfKw/9znv4yvJynLv4uLiV2dBoDiBf4qP3/ARuCRABEFAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghgg0Aj8i0JO4OzsrPv69Wv+hi2qPHr0qNvf39+iI97soRIh4f3z58/u7du3SXX7Xt7Z2enevHmzfQe+oSN2apSAPj09TSrb+XKI/f379+08+A0cNRE2ANkupk+ACNPvkSPcAAEibACyXUyfABGm3yNHuAECRNgAZLuYPgEirKlHu7u7XdyytGwHAd8jjNyng4OD7vnz51dbPT8/7z58+NB9+/bt6jU/TI+AGWHEnrx48eJ/EsSmHzx40L18+fLyzxF3ZVMjEyDCiEDjMYZZS5wiPXnyZFbJaxMhQIQRGzHvWR7XCyOCXsOmiDAi1HmPMMQjDpbpEiDCiL358eNHurW/5SnWdIBbXiDCiA38/Pnzrce2YyZ4//59F3ePLNMl4PbpiL2J0L979+7yDtHDhw8vtzzvdGnEXdvUigSIsCLAWavHp/+qM0BcXMd/q25n1vF57TYBp0a3mUzilePj4+7k5KSLb6gt6ydAhPUzXnoPR0dHl79WGTNCfBnn1uvSCJdegQhLI1vvCk+fPu2ePXt2tZOYEV6/fn31dz+shwAR1sP1cqvLntbEN9MxA9xcYjsxS1jWR4AIa2Ibzx0tc44fYX/16lV6NDFLXH+YL32jwiACRBiEbf5KcXoTIsQSpzXx4N28Ja4BQoK7rgXiydbHjx/P25TaQAJEGAguWy0+2Q8PD6/Ki4R8EVl+bzBOnZY95fq9rj9zAkTI2SxdidBHqG9+skdw43borCXO/ZcJdraPWdv22uIEiLA4q7nvvCug8WTqzQveOH26fodo7g6uFe/a17W3+nFBAkRYENRdb1vkkz1CH9cPsVy/jrhr27PqMYvENYNlHAIesRiBYwRy0V+8iXP8+/fvX11Mr7L7ECueb/r48eMqm7FuI2BGWDEG8cm+7G3NEOfmdcTQw4h9/55lhm7DekRYKQPZF2ArbXTAyu4kDYB2YxUzwg0gi/41ztHnfQG26HbGel/crVrm7tNY+/1btkOEAZ2M05r4FB7r9GbAIdxaZYrHdOsgJ/wCEQY0J74TmOKnbxxT9n3FgGGWWsVdowHtjt9Nnvf7yQM2aZU/TIAIAxrw6dOnAWtZZcoEnBpNuTuObWMEiLAx1HY0ZQJEmHJ3HNvGCBBhY6jtaMoEiJB0Z29vL6ls58vxPcO8/zfrdo5qvKO+d3Fx8Wu8zf1dW4p/cPzLly/dtv9Ts/EbcvGAHhHyfBIhZ6NSiIBTo0LNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiEC/wGgKKC4YMA4TAAAAABJRU5ErkJggg=="
        />
      </DescriptionsItem>
      </Descriptions>
      <Descriptions :title="$t('leaveApprove.name.remainingVacation')">
        <DescriptionsItem :label="$t('remainingVacation.field.id_rem_vac')">{{remainingVacation.idRemVac}}</DescriptionsItem>
        <DescriptionsItem :label="$t('remainingVacation.field.id_emp')">{{remainingVacation.idEmp}}</DescriptionsItem>
        <DescriptionsItem
          :label="$t('remainingVacation.field.annual_leave_days')"
          >{{ remainingVacation.annualLeaveDays }}</DescriptionsItem
        >
        <DescriptionsItem
          :label="$t('remainingVacation.field.maternity_leave_days')"
          >{{ remainingVacation.maternityLeaveDays }}</DescriptionsItem
        >
        <DescriptionsItem
          :label="$t('remainingVacation.field.paternity_leave_days')"
          >{{ remainingVacation.paternityLeaveDays }}</DescriptionsItem
        >
        <DescriptionsItem
          :label="$t('remainingVacation.field.remaining_annual_leave_days')"
          >{{ remainingVacation.remainingAnnualLeaveDays }}</DescriptionsItem
        >
        <DescriptionsItem
          :label="$t('remainingVacation.field.remaining_maternity_leave_days')"
          >{{ remainingVacation.remainingMaternityLeaveDays }}</DescriptionsItem
        >
        <DescriptionsItem
          :label="$t('remainingVacation.field.remaining_paternity_leave_days')"
          >{{ remainingVacation.remainingPaternityLeaveDays }}</DescriptionsItem
        >
        <DescriptionsItem :label="$t('remainingVacation.field.year')">{{
          remainingVacation.year
        }}</DescriptionsItem>
      </Descriptions>
      <Descriptions :title="$t('leaveApprove.name.historyLeave')">
      </Descriptions> -->
      <Row>
        <Col :span="24" >
          <Form :model="searchForm">
            <Row :gutter="30">
              <Col span="6">
                    <FormItem :label="$t('leave.field.id_lea_typ')" name="idLeaTyp">
                      <!--关联表的下拉选择-->
                      <Select
                              v-model:value="searchForm.idLeaTyp"
                              :placeholder="$t('leave.validate.required.id_lea_typ')"
                              :dropdownStyle="{ zIndex: 9999999950 }"
                      >
                                            <SelectOption :value="null">{{ $t('attendance.name.select_all') }}</SelectOption>
                          <SelectOption :key="sk" v-for="(item,sk) in selectList['leaveTypeList']" :value="item['idLeaTyp']">{{ item['leaveTypeName'] }}</SelectOption>
                      </Select>
                  </FormItem>
                </Col>
              <Col :xs="24" :sm="8">
                <FormItem :label="$t('attendance.name.dateRange')" name="dateRange">
                  <RangePicker :allowClear="false" v-model:value="rangePickerDate" @change="rangeChange"/>
                </FormItem>
              </Col>
              <Col :xs="24" :sm="8" class="text-right">
                <Button type="primary" @click="search_submit">{{$t('public.name.search')}}</Button>&nbsp;
                <Button @click="search_reset">{{$t('public.name.reset')}}</Button>&nbsp;
                
              </Col>
            </Row>
          </Form>
        </Col>
        <Col :span="24">
          <Table
            :columns="columns"
            :dataSource="list"
            :scroll="{ x: true }"
            rowKey="idLea"
            :loading="loading"
            :pagination="false"
          >
          </Table>
        </Col>
      </Row>
    </Col>
    </Row>
 
      </LayoutContent>
  </Layout>
  <LeaveReject ref="refLeaveReject" @updateList="loadData"></LeaveReject>
</template>

<script>
import { createVNode } from "vue";
import {
  Descriptions,
  DescriptionsItem,
  Row,
  Col,
  Table,
  Image,
  message,
  Typography,
  Layout,
  Form,
  Input, 
  Select, 
  RangePicker,
  Button,
  Modal,
  Card,
} from "ant-design-vue";
import { LoadingOutlined, PlusOutlined,ExclamationCircleOutlined } from "@ant-design/icons-vue";
import { LeaveGet } from "@/api/LeaveGet";
import { LeaveApproveNew } from "@/api/LeaveApproveNew";
import { RemainingGetByIdEmp } from "@/api/RemainingGetByIdEmp";
import { LeaveGetHistoryLeave } from "@/api/LeaveGetHistoryLeave";
import { LeaveTypeListAll } from "@/api/LeaveTypeListAll"
import { LeaveGetTotalSickLeaveDays } from "@/api/LeaveGetTotalSickLeaveDays"
import LeaveReject from "@/components/Home/LeaveReject";
import LanguageButton from "@/components/Common/LanguageButton";
import moment from "moment";

export default {
  name: "LeaveApprove",
  components: {
    Layout,
    LoadingOutlined,
    PlusOutlined,
    ExclamationCircleOutlined,
    Descriptions,
    DescriptionsItem,
    TypographyTitle: Typography.Title,
    Image,
    Row,
    Col,
    Table,
    message,
    Form,
    FormItem: Form.Item,
    Button,
    Input,
    Select,
    SelectOption: Select.Option,
    RangePicker,
    Modal,
    Card,
    LeaveReject,
    LanguageButton,
  },
  data() {
    return {
      idLea: null,
      rangePickerDate:["",""],
      searchForm: {
        idLeaTyp: null,
        // leaveType: null,
        startDate: null,
        endDate: null,
      },
      visable:false,
      data: {},
      remainingVacation: {},
      historySickLeaveDays: 0,
      selectList: {
        leaveTypeList: [],
        // leaveTypeList: [
        //   { value: 1, label: "調休" },
        //   { value: 2, label: "年假" },
        //   { value: 3, label: "產假" },
        //   { value: 4, label: "侍產假" },
        //   { value: 5, label: "事假" },
        //   { value: 6, label: "病假" },
        //   { value: 7, label: "婚假" },
        // ],
        statusList: [{value: 0,label: '待發送'},{value: 1,label: '待審批'},{value: 2,label: '已拒絕'},{value: 3,label: '已通過'}],
      },
      loading: false,
      list: [],
      columns: [
        {
          title: this.$t("leave.table.id_lea"),
          fixed: "left",
          dataIndex: "idLea",
          key: "idLea",
        },
        {
          title: this.$t("leave.table.id_emp"),
          dataIndex: "employeeNameTw",
          key: "employeeNameTw",
        },
        {
          title: this.$t("leave.table.leave_type"),
          dataIndex: "leaveTypeLeaveTypeName",
          key: "leaveTypeLeaveTypeName"
        },
        { title: this.$t("leave.table.status"), dataIndex: "status", key: "status", customRender: ({text,record}) =>{
              return this.selectList.statusList.find(item=>item.value===text).label
            }
          },
        {
          title: this.$t("leave.table.start_time"),
          dataIndex: "startTime",
          key: "startTime",
          customRender: ({ text, record }) => {
            if (
              record.leaveType === 2 ||
              record.leaveType === 3 ||
              record.leaveType === 4
            ) {
              return moment(text).format("YYYY-MM-DD");
            } else {
              return moment(text).format("YYYY-MM-DD HH:mm:ss");
            }
          },
        },
        {
          title: this.$t("leave.table.end_time"),
          dataIndex: "endTime",
          key: "endTime",
          customRender: ({ text, record }) => {
            if (
              record.leaveType === 2 ||
              record.leaveType === 3 ||
              record.leaveType === 4
            ) {
              return moment(text).format("YYYY-MM-DD");
            } else {
              return moment(text).format("YYYY-MM-DD HH:mm:ss");
            }
          },
        },
        {
          title: this.$t("leave.table.duration"),
          dataIndex: "duration",
          key: "duration",
           customRender: ({text,record}) =>{
              // var days =  Math.floor(text/480);
              // var hours =  Math.floor(text%480/60);
              // var minutes =  text%60;
              // var result = '';
              // if(days !== 0){
              //   result = days + '天';
              // }
              // if(hours !== 0){
              //   result = result + hours + "小時"
              // }
              // if(minutes !== 0){
              //   result = result + minutes + "分鐘"
              // }
              // return result;
              return text + "天";
            }
        },
        {
          title: this.$t("leave.table.reason"),
          dataIndex: "reason",
          key: "reason",
        },
        // {
        //   title: this.$t("leave.table.picture_url"),
        //   dataIndex: "pictureUrl",
        //   key: "pictureUrl",
        // },
        {
          title: this.$t("leave.table.approver_id"),
          dataIndex: "approver",
          key: "approver",
        },
        {
          title: this.$t("leave.table.approve_time"),
          dataIndex: "approveTime",
          key: "approveTime",
        },
        { title: this.$t("leave.table.approver2_id"), dataIndex: "approver2", key: "approver2" },
        { title: this.$t("leave.table.approve2_time"), dataIndex: "approve2Time", key: "approve2Time" },
        // { title: this.$t("leave.table.cc"), dataIndex: "cc", key: "cc" },
        {
          title: this.$t("leave.table.remark"),
          dataIndex: "remark",
          key: "remark",
        },
        {
          key: "action",
          align: "right",
          slots: { title: "actionTitle", customRender: "action" },
        },
      ],
    };
  },
  computed: {
    totalSickLeaveDays: function(){
      return this.historySickLeaveDays + this.remainingVacation.remainingSickLeaveDays
    }
  },
  mounted() {
    this.idLea = this.$route.params.idLea
    this.loadData();
    
  },
  methods: {
    loadData() {
      let api = new LeaveGet();
      api
        .get({
          idLea: this.idLea,
        })
        .then((response, any) => {
          if (0 == parseInt(response.data.code)) {
            this.getLeaveTypeList();
            this.data = response.data.data;
            //判定当前登录者是否有审批权限
            if(this.data.approverId !== this.$store.getters.getId && this.data.approver2Id !== this.$store.getters.getId){
              message.error(this.$t("public.name.no_permission"));
              this.$router.push({ name: "Dashboard" });
              return;
            }else{
              this.visable = true;
            }
            this.getRemainingVacation();
            this.getTotalSickLeaveDays();
            this.get_list();
          } else {
            message.error(response.data.msg);
          }
        });
    },
    reject(){
      this.$refs.refLeaveReject.show(this.idLea);
    },
    approve(){
      Modal.confirm({
        title: this.$t("leaveApprove.name.are_you_sure_pass") + "?",
        content: this.$t("public.name.action_cannot_resumed"),
        icon: createVNode(ExclamationCircleOutlined),
        okText: this.$t("public.name.yes"),
        okType: "danger",
        cancelText: this.$t("public.name.no"),
        onOk: () => {
          const api = new LeaveApproveNew();
          api.post({ idLea: this.idLea }).then((response) => {
            if (0 === parseInt(response.data.code)) {
              this.loadData()
              message.success(response.data.msg);
            } else {
              message.error(response.data.msg);
            }
          });
        },
      });
    },
    getRemainingVacation() {
      let api = new RemainingGetByIdEmp();
      api
        .get({
          idEmp: this.data.idEmp,
        })
        .then((response, any) => {
          if (0 == parseInt(response.data.code)) {
            this.remainingVacation = response.data.data;
          } else {
            message.error(response.data.msg);
          }
        });
    },
    getTotalSickLeaveDays() {
      let api = new LeaveGetTotalSickLeaveDays();
      api
        .get({
          idEmp: this.data.idEmp,
        })
        .then((response, any) => {
          if (0 == parseInt(response.data.code)) {
            this.historySickLeaveDays = response.data.data;
          } else {
            message.error(response.data.msg);
          }
        });
    },
    get_list() {
      this.loading = true;
      const api = new LeaveGetHistoryLeave();
      const getData = {
        idEmp: this.data.idEmp,
      };
      if (this.searchForm.idLeaTyp != "") getData.idLeaTyp = this.searchForm.idLeaTyp
      if (this.searchForm.startDate != "") getData.startDate = this.searchForm.startDate
      if (this.searchForm.endDate != "") getData.endDate = this.searchForm.endDate
      api.get(getData).then((response) => {
        this.loading = false;
        if (0 === parseInt(response.data.code)) {
          const dataTmp = response.data;
          this.list = dataTmp.data;
        } else {
          this.list = [];
        }
      });
    },
    search_submit() {
      this.get_list()
    },
    search_reset() {
      this.rangePickerDate = ["",""],
      this.searchForm = {
        leaveType: null,
        startDate: null,
        endDate: null,
      },
      this.get_list()
    },
    rangeChange(dates){
      this.searchForm.startDate = dates[0].format("YYYY-MM-DD")
      this.searchForm.endDate = dates[1].format("YYYY-MM-DD")
    },
    getLeaveTypeList() {
      const api = new LeaveTypeListAll();
      api.get().then((response) => {
        if (0 == parseInt(response.data.code)) {
            this.selectList.leaveTypeList = response.data.data;
        } else {
            message.error(response.data.msg);
        }
      });
    },
  },
};
</script>


<style lang="less">
@import url("~@/assets/less/leaveApprove.less");
</style>